import { FC } from "react";
import { X } from "lucide-react";
import { Button } from "../../../../molecules/Button";
import { CLOSE_ICON_STYLES } from "../../../../../styles";
import { PureVoidFunc } from "../../../../../../forms/types";
import { MODAL_ROW_GROUP_STYLES } from "../../../../detailedPages";

export const FieldsGroup: FC<
  React.PropsWithChildren<{ groupId?: string; handleRemove: PureVoidFunc }>
> = ({ children, groupId, handleRemove }) => {
  return (
    <section
      // group/row: lets row content react to focus inside the row (group-focus-within/row:).
      className={`group/row ${MODAL_ROW_GROUP_STYLES} flex align-middle pl-1`}
      aria-label={groupId}
    >
      <div className="divide-y divide-stone-200 dark:divide-stone-700 grow align-center">
        {children}
      </div>
      <Button
        title="Remove entry"
        className={`${CLOSE_ICON_STYLES} min-w-6 my-auto relative`}
        onClick={handleRemove}
        buttonType="iconOnly"
      >
        <X />
      </Button>
    </section>
  );
};
